import React, { useState, useEffect } from 'react';
import { SpinnerIcon } from '../../Icons';

interface Props {
  initialValue?: string;
  isEditing?: boolean;
  isSubmitting: boolean;
  onSubmit: (text: string) => Promise<boolean>;
  onCancel?: () => void;
}

export const PropertyCommentForm: React.FC<Props> = ({
  initialValue = '',
  isEditing = false,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  const [content, setContent] = useState(initialValue);

  useEffect(() => {
    setContent(initialValue);
  }, [initialValue]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim() || isSubmitting) return;
    const success = await onSubmit(content);
    if (success && !isEditing) {
      setContent('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="relative">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder={
            isEditing
              ? 'Edita tu comentario comercial...'
              : 'Escribe un comentario comercial sobre este inmueble (seguimiento, cliente interesado, condiciones)...'
          }
          rows={isEditing ? 3 : 2}
          maxLength={1000}
          disabled={isSubmitting}
          className="w-full text-xs sm:text-sm text-gray-800 bg-white border border-teal-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-100 rounded-xl p-3 sm:p-3.5 placeholder-gray-400 outline-none transition-all resize-y disabled:opacity-50"
        />
        <div className="text-[10px] text-gray-400 text-right pr-1">
          {content.length}/1000 caracteres
        </div>
      </div>

      <div className="flex items-center justify-end gap-2">
        {isEditing && onCancel && (
          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            className="px-4 py-2 text-[11px] font-bold text-gray-500 hover:text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Cancelar
          </button>
        )}
        <button
          type="submit"
          disabled={!content.trim() || isSubmitting}
          className="px-5 py-2 text-[11px] font-black uppercase tracking-wider bg-teal-600 hover:bg-teal-700 text-white rounded-lg shadow-sm transition-all flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <>
              <SpinnerIcon className="w-3.5 h-3.5 animate-spin" />
              Guardando...
            </>
          ) : isEditing ? (
            'Actualizar'
          ) : (
            'Comentar'
          )}
        </button>
      </div>
    </form>
  );
};
